import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Input from "../shared/Input";
import { fetchData, fetchFormData, getValueLabel } from "../../utils/options";
import topTost from "../../utils/topTost";
import SelectDropdown from "../shared/SelectDropdown";

const LeadPaymentCreate = ({ permission }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const [role, setRole] = useState("");
  const [bankData, setBankData] = useState([]);
  const [loanTypeData, setLoanTypeData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    bank_name: "",
    loan_type: "",
    payouts: "",
    status: "",
    created_by: "",
    payouts_type: "",
  });
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchAllData = async () => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);
    const branchData = await fetchData("getallbank", {}, "GET");
    const loanTypeData = await fetchFormData(
      "list-loan-types",
      formData,
      "POST"
    );

    // Handle Branch Data
    if (branchData) {
      const branches = branchData.data;
      setBankData(getValueLabel(branches, "lender_name", "id") || []);
    }
    if (loanTypeData) {
      const loanType = loanTypeData.data;
      setLoanTypeData(getValueLabel(loanType, "loan_type_name", "id") || []);
    }
  };

  const handleBankChange = (value) => {
    if (value) {
      setFormData((prev) => ({
        ...prev,
        bank_name: value.value,
      }));
    }
  };

  const handleloanTypeChange = (value) => {
    if (value) {
      setFormData((prev) => ({
        ...prev,
        loan_type: value.value,
      }));
    }
  };
  const fetchDetails = async (id) => {
    try {
      const formData = new FormData();

      formData.append("id", id); // Send ID in the form data
      formData.append("userId", userId);
      const result = await fetchFormData(
        "get-by-id-lead-payment-bank",
        formData,
        "POST"
      );

      if (result && result.data) {
        setFormData(result.data);
      } else {
        console.warn("Bank data not found.");
        setFormData("");
      }
    } catch (error) {
      console.error("Failed to fetch bank details:", error);
      setFormData("");
    }
  };

  useEffect(() => {
    fetchAllData();
    if (id) {
      fetchDetails(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const data = new FormData(); // avoid shadowing the state variable
    data.append("branchID", 1);
    data.append("bank_name", formData.bank_name || "");
    data.append("loan_type", formData.loan_type || "");
    data.append("payouts", formData.payouts || "");
    data.append("status", 1);
    data.append("created_by", userId);
    data.append("moduleId", M_id);
    data.append("payouts_type", formData.payouts_type || "");
    try {
      let res;

      if (id) {
        data.append("id", id);
        data.append("userId", userId);
        // Edit logic - update role
        res = await fetchFormData("update-lead-payment-bank", data, "POST");
    
      } else {
        // Create logic - new role
        res = await fetchFormData("add-lead-payment-bank", data, "POST");
      }
      if ((res && res.code === 200) || res.code === 201) {
        topTost({
          title: res.message[{}],
          icon: "success",
        });
        navigate(`/payout/inquiry-payment-list?id=${M_id}`);
      } else if (res && res.code === 422) {
        topTost({
          title: Array.isArray(res.message)
            ? res.message[0]
            : res.message || "Validation error",
          icon: "error",
        });
      } else {
        console.error("Role operation failed", res);
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  console.log(formData);
  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-5 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                <span className="d-block mb-2">
                  {id ? "Edit Lead Payout:" : "Add Lead Payout:"}
                </span>
              </h5>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="row mb-4">
                <div className="col-md-2 py-3">
                  <label className="fw-semibold">
                    Lender :<span className="text-danger px-1">*</span>
                  </label>
                </div>
                <div className="col-lg-4">
                  <SelectDropdown
                    options={bankData}
                    icon="feather-home"
                    name="bank_name"
                    value={Number(formData.bank_name)}
                    selectedOption={
                      bankData.find(
                        (opt) => opt.value === formData.bank_name
                      ) || null
                    }
                    defaultSelect="Select Lender"
                    onSelectOption={handleBankChange}
                  />
                </div>
                <div className="col-md-2 py-3">
                  <label className="fw-semibold">
                    Loan Type: <span className="text-danger px-1">*</span>
                  </label>
                </div>
                <div className="col-lg-4">
                  <SelectDropdown
                    options={loanTypeData}
                    icon="feather-settings"
                    name="bank_name"
                    value={Number(formData.loan_type)}
                    selectedOption={
                      loanTypeData.find(
                        (opt) => opt.value === formData.loan_type
                      ) || null
                    }
                    defaultSelect="Select Loan Type"
                    onSelectOption={handleloanTypeChange}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Input
                    icon="feather-cash"
                    label="Payout"
                    labelId="payoutInput"
                    placeholder="Payout"
                    name="payouts"
                    value={formData.payouts}
                    required
                    onChange={(name, value) => {
                      const numericValue = parseFloat(value);

                      if (formData.payouts_type === "%" && numericValue > 100) {
                        topTost({
                          title: "Payout percentage cannot exceed 100%",
                          icon: "error",
                        });
                        return;
                      }

                      setFormData((prev) => ({ ...prev, payouts: value }));
                    }}
                  />
                </div>
                <div className="col-md-2 py-3">
                  <label className="fw-semibold">Payout Type:</label>
                </div>
                <div className="col-lg-4">
                  <SelectDropdown
                    options={[
                      { label: "%", value: "%" },
                      { label: "Amount", value: "₹" },
                    ]}
                    icon="feather-percent"
                    name="payouts_type"
                    value={formData.payouts_type}
                    selectedOption={
                      [
                        { label: "%", value: "%" },
                        { label: "Amount", value: "₹" },
                      ].find((opt) => opt.value === formData.payouts_type) ||
                      null
                    }
                    defaultSelect="Select Payout Type"
                    onSelectOption={(selected) =>
                      setFormData((prev) => ({
                        ...prev,
                        payouts_type: selected.value,
                      }))
                    }
                  />
                </div>
              </div>

              <div className="mt-5 customButton">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadPaymentCreate;
